/**
 * Простой DatePicker через native <input type="date">.
 *
 * Использует нативный date picker браузера для максимальной совместимости.
 */

import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/shared/lib/cn';

import styles from './DatePicker.module.css';

export interface DatePickerProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
}

export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(function DatePicker(
  { label, error, className, ...rest },
  ref,
) {
  return (
    <div className={cn(styles.wrapper, className)}>
      {label !== undefined && <label className={styles.label}>{label}</label>}
      <input
        {...rest}
        ref={ref}
        type="date"
        className={cn(styles.input, error !== undefined && styles.error)}
      />
      {error !== undefined && <span className={styles.errorText}>{error}</span>}
    </div>
  );
});
